import pino from 'pino';

const logger = pino({
  level: process.env.DD_TRACE_LOG_LEVEL || 'info',
});

export default logger;
